import React from 'react';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ size = 'medium', fullScreen = false }) => {
  const sizeClasses = {
    small: 'w-6 h-6 border-2',
    medium: 'w-10 h-10 border-[3px]',
    large: 'w-14 h-14 border-4',
  };

  const loaderContent = (
    <div className="flex flex-col items-center gap-3">
      <div className={`${sizeClasses[size]} border-beige-300 border-t-brand-500 rounded-full animate-spin`} />
      {size !== 'small' && (
        <p className="text-xs text-sage-400 font-medium">Loading...</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center py-20">
        {loaderContent}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center">
      {loaderContent}
    </div>
  );
};

export default Loader;
